import { Button, Card, CardContent, Grid, InputLabel, Tooltip, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { getEstablecimientosTipoO } from "../../../../redux/actions/establecimiento";
import {
  clearDatosEstablecimiento,
  getDatosEstablecimiento,
} from "../../../../redux/actions/obra";
import FormikActions from "../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../commons/formik/FormikAutocomplete";
import { StyledNuevaObra, StyledUbicacionObra } from "../../../styled/Obras";
import { ubicacionFormValidation } from "../validation/formValidation";
import NewEstablecimientoDialog from "./NewEstablecimientoDialog";

const UbicacionForm = ({
  establecimientos,
  setOpenEstablecimientoDialog,
  datosEstablecimiento,
  openEstablecimientoDialog,
  handleSumbitNewEstablecimiento,
  handleSubmitUbicacion,
  formModel,
  disabled,
}) => {
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={formModel}
      enableReinitialize={true}
      onSubmit={handleSubmitUbicacion}
      validationSchema={ubicacionFormValidation}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <Grid container spacing={3}>
            <StyledNuevaObra.PaddingContainer item xs={12}>
              <Typography variant="h6">Ubicación de la Obra</Typography>
            </StyledNuevaObra.PaddingContainer>
            <StyledNuevaObra.PaddingContainer item xs={6}>
              <Card>
                <StyledUbicacionObra.Title>Establecimiento *</StyledUbicacionObra.Title>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={10}>
                      <FormikAutocomplete
                        name="idDependenciaEmpleador"
                        variant="standard"
                        disabled={disabled}
                        options={establecimientos.filter((e) => e.nombre)}
                        getOptions={() => dispatch(getEstablecimientosTipoO())}
                        renderOption={(option) => option.nombre}
                        filterOptions={(option) => option.nombre}
                        callBack={(value) => {
                          if (value) {
                            dispatch(getDatosEstablecimiento(value.id));
                          } else {
                            dispatch(clearDatosEstablecimiento());
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={2} > 
                      <Tooltip arrow title="Nuevo establecimiento">
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={disabled}
                          onClick={() => setOpenEstablecimientoDialog(true)}
                        >
                          <StyledUbicacionObra.Icon />
                        </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </StyledNuevaObra.PaddingContainer>
            <StyledNuevaObra.PaddingContainer
              item
              xs={12}
              sx={{ display: "flex" }}
            >
              <InputLabel>Dirección:</InputLabel>
              <StyledUbicacionObra.TextValue>
                {datosEstablecimiento.domicilio || "Sin dirección"}
              </StyledUbicacionObra.TextValue>
            </StyledNuevaObra.PaddingContainer>
            <StyledNuevaObra.PaddingContainer
              item
              xs={12}
              sx={{ display: "flex" }}
            >
              <InputLabel>Dirección GPS:</InputLabel>
              <StyledUbicacionObra.TextValue
                sx={{
                  display: "flex",
                  padding: 2
                }}
              >
                <StyledUbicacionObra.LatitudContainer>
                  <StyledUbicacionObra.Latitud>Latitud</StyledUbicacionObra.Latitud>
                  <Typography variant="body2">
                    {datosEstablecimiento.latitud
                      ? `${datosEstablecimiento.latitud}°`
                      : "Sin latitud"}
                  </Typography>
                </StyledUbicacionObra.LatitudContainer>
                <StyledUbicacionObra.LongitudContainer>
                  <StyledUbicacionObra.Longitud>Longitud</StyledUbicacionObra.Longitud>
                  <Typography variant="body2">
                    {datosEstablecimiento.longitud
                      ? `${datosEstablecimiento.longitud}°`
                      : "Sin longitud"}
                  </Typography>
                </StyledUbicacionObra.LongitudContainer>
              </StyledUbicacionObra.TextValue>
              <NewEstablecimientoDialog
                open={openEstablecimientoDialog}
                handleClose={() => setOpenEstablecimientoDialog(false)}
                handleSumbit={(v) => handleSumbitNewEstablecimiento(v, setFieldValue)}
                fechaInicioObra={formModel.fechaInicioObra}
              />
            </StyledNuevaObra.PaddingContainer>
          </Grid>
          <StyledNuevaObra.ButtonContainer>
            <FormikActions
              submit="Siguiente"

            />
          </StyledNuevaObra.ButtonContainer>
        </Form>
      )}
    </Formik>
  );
};

export default UbicacionForm;
